import type { OpenUrlWithKind } from '@api/generated/models';
import { FlexibleBaseSpecification, FlexibleModelBase } from './flexible_base';

export interface FlexibleButtonSpecification extends FlexibleBaseSpecification {
	title: string;
	url: string;
	requiresAuthentication: boolean;
	openAnotherApp: boolean;
	hasBrandedNavbar: boolean;
	openUrlWith: OpenUrlWithKind;
}

export class FlexibleButtonModel extends FlexibleModelBase {
	public readonly title: string;
	public readonly url: string;
	public readonly requiresAuthentication: boolean;
	public readonly openAnotherApp: boolean;
	public readonly hasBrandedNavbar: boolean;
	public readonly openUrlWith: OpenUrlWithKind;

	constructor(spec: FlexibleButtonSpecification) {
		super(spec);

		this.title = spec.title;
		this.url = spec.url;
		this.requiresAuthentication = spec.requiresAuthentication;
		this.openAnotherApp = spec.openAnotherApp;
		this.hasBrandedNavbar = spec.hasBrandedNavbar;
		this.openUrlWith = spec.openUrlWith;
	}
}
